// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cNYyT","fullView":"styles_fullView__2piqw"};